module.exports = __webpack_public_path__ + "img/aboutus_logo1.bc79136f.png";